module.exports = __webpack_public_path__ + "img/logo.5b1c14fc.png";